import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.heading',
		defaultMessage: 'Project hierarchy',
		description: 'Title of project hierarchy page',
	},
	jwmSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.jwm-spork',
		defaultMessage: 'Jira',
		description: 'Header of the Jira column in the field mapping table',
	},
});
